import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)



import violation from './components/ViolationList'
import Search from './components/Search.vue'
import SceneBill from './components/SceneBill.vue'
import SceneBillPay from './components/SceneBillPay.vue'
import success from './components/Success.vue'
import Order from './components/Order.vue'
import Ticketpay from './components/Ticketpay.vue'

export default new Router({
  routes: [
    {
      path: '/',
      name: 'dash',
      component: violation
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/pay',
      name: 'sceneBill',
      component: SceneBill
    },
    {
      path: '/paying',
      name: 'sceneBillPay',
      component: SceneBillPay
    },
    {
      path: '/success',
      name: 'success',
      component: success
    },
    {
      path: '/order',
      name: 'order',
      component: Order
    },
    {
      path: '/ticketpay',
      name: 'ticketpay',
      component: Ticketpay
    }
  ]
})
